// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"7793":"cc78bf791fc7f777","42150":"f67825cccaa8bcf1","42199":"c6a79955814704f9","70816":"d7155ce511420653","75622":"771335c4bc1c09bd","98637":"abf780cea46d2af6"}[chunkId] + ".css";
};